module.exports = __webpack_public_path__ + "static/media/outros.3945d28a.svg";